import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/styles/index.styl'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'lib-flexible/flexible.js'

Vue.use(Vant)
Vue.config.productionTip = false

new Vue({ router, store, render: function (h) { return h(App) } }).$mount('#app')
